import { loadStripe } from "@stripe/stripe-js";
import { config } from "../envConfig";

export let isLoaded = false;

// if (!config.STRIPE_PUBLISHABLE_KEY) {
//   throw new Error(
//     "Stripe failed to setup. Check your environment variables and try again"
//   );
// }
export const getOptions = () => ({
  pk: config.STRIPE_PUBLISHABLE_KEY,
  apiVersion: config.STRIPE_API_VERSION,
  locale: config.STRIPE_LOCALE,
});

export const configureStripe = () => {
  const pk = getOptions().pk;
  if (pk) {
    loadStripe(pk).then(() => {
      isLoaded = true;
    });
  }
};
